import '../style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import 'react-phone-input-2/lib/style.css';
import { IEditReportState } from '../models/IEditReportState';
import Popover from 'react-bootstrap/Popover';
import 'bootstrap/dist/css/bootstrap.min.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import 'react-datepicker/dist/react-datepicker.css';
import Select, { MultiValue } from 'react-select';
import { IRestorationPledgeTab, IResultsAndBenefitsItem } from '../models/IEditReportState';
import QueryService from '../../../../shared/queryService';
import ConfigService from '../../../../shared/configService';
import { IRefPledgeEcosystemTypeFeature, IRefPledgeInitiativeFeature } from '../models/IRefFeature';
import { IFeature } from '@esri/arcgis-rest-types';
import { ToastContainer, toast } from 'react-toastify';
import Utils from '../../../../shared/utils';
import IReportMainFeature from '../models/IReportMainFeature';
import ReactDatePicker from 'react-datepicker';

const RestorationPledge = (props: {state: IEditReportState, setState: Function, validateData: Function}) => {
  const {t} = useTranslation('reports');

  //Popup buttons
  let baselineYearPopoverBtn: HTMLButtonElement;
  let pledgeEndDatePopoverBtn: HTMLButtonElement;

  const baselineYearPopover = (
    <Popover id="baselinePopover">
        <div dangerouslySetInnerHTML={{__html:t('newReport.restorationPledge.baselineYearExplanation')}}></div>
        <div className="popoverActionsDiv">
          <button onClick={() => togglePopup1()}>{t('newReport.restorationPledge.gotIt')}</button>
        </div> 
    </Popover>
  );

  const pledgeEndDatePopover = (
    <Popover id="pledgeEndDatePopover">
      <div dangerouslySetInnerHTML={{__html:t('newReport.restorationPledge.pledgeEndDateExplanation')}}></div>
      <div className="popoverActionsDiv">
        <button onClick={() => togglePopup2()}>{t('newReport.restorationPledge.gotIt')}</button>
      </div>
    </Popover>
  );

  //Popups toggle
  const togglePopup1 = () => {
    if(baselineYearPopoverBtn) {
      baselineYearPopoverBtn.click();
    }
  }

  const togglePopup2 = () => {
    if(pledgeEndDatePopoverBtn) {
      pledgeEndDatePopoverBtn.click();
    }
  }

  /**
   * Get otherInitiativeInputEnabled 
   * @param val
   */
   const getOtherInitiativeInputEnabled = (val: string): boolean => {
    return val.split(',').some((i: string) => i === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
  }

  /**
   * Get otherEcosystemInputEnabled 
   * @param val
   */
   const getOtherEcosystemInputEnabled = (val: string): boolean => {
    return val.split(',').some((i: string) => i === ConfigService.getConfig().agol.referenceTables.otherKeyValue);
  }

  /**
   * Local state
   */
  interface ILocalState {
    reportLayerIndex: number;
    importReportDisabled: boolean;
    refPledgeInitiativeFeature: IRefPledgeInitiativeFeature[];
    refPledgeEcosystemTypeFeature: IRefPledgeEcosystemTypeFeature[];
    otherInitiativeInputEnabled: boolean;
    otherEcosystemInputEnabled: boolean;
    anteriorReport?: IReportMainFeature;
  }
  const [localState, setTheLocalState] = useState<ILocalState>({
    reportLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportMain.index,
    importReportDisabled: true,
    refPledgeInitiativeFeature: [],
    refPledgeEcosystemTypeFeature: [],
    otherInitiativeInputEnabled: getOtherInitiativeInputEnabled(props.state.restorationPledgeTab?.linked_init || ''),
    otherEcosystemInputEnabled: getOtherEcosystemInputEnabled(props.state.restorationPledgeTab?.ecosystems || '')
  });

  // Use effect
  useEffect(() => {
    //Reference table
    getRefFeatures();
  }, []);
  

  /**
   * Set parent state
   * @param prop
   * @param value 
   */
   const setParentState = (prop: string, value: any) => {

    if(props.state) {
      const obj: IEditReportState = {...props.state};
      const subObj: IRestorationPledgeTab = { ...obj.restorationPledgeTab } as IRestorationPledgeTab;

      (subObj as any)[prop] = value;
      
      // If ecosystem, set RB ha_intervention_types
      if (prop === 'ecosystems') {
        obj.resultsAndBenefitsTab?.resultsAndBenefitsItems?.forEach((i: IResultsAndBenefitsItem) => {
          i.hectaresUnderRestorationTab.ha_intervention_types = '';
        });
      }

      // Check isOK
      props.validateData(subObj);

      obj.restorationPledgeTab = subObj;

      props.setState(obj);
    }
  }


  /**
   * Handle pledge end date change
   * @param date
   */
  const handlePledgeEndDateChange = (date: Date) => {
    setParentState('pledge_end', date.getTime());
  }

  /**
   *get end date change
   * @param date
   */
  const getPledgeEndDate = (): Date | undefined=> {
    if (props.state.restorationPledgeTab?.pledge_end) {
      return new Date(props.state.restorationPledgeTab?.pledge_end);// ? new Date(props.state.restorationPledgeTab?.pledge_end): new Date();
    }

    return undefined;
  }
  
  /**
   * Handle initiative change
   * @param date
   */
  const handleInitiativeChange = (items: MultiValue<{label: string | undefined, value: string | undefined}>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('linked_init', val);
    
    const obj: ILocalState = { ...localState };
    obj.otherInitiativeInputEnabled = getOtherInitiativeInputEnabled(val);
    setTheLocalState(obj);
  }
  
  /**
   * Handle ecosystem change
   * @param date
   */
  const handleEcosystemChange = (items: MultiValue<{label: string | undefined, value: string | undefined}>) => {
    const val: string = items && items.length ? items.map(i => i.value).join(',') : '';
    setParentState('ecosystems', val);

    const obj: ILocalState = { ...localState };
    obj.otherEcosystemInputEnabled = getOtherEcosystemInputEnabled(val);
    setTheLocalState(obj);
  }

  /**
   * Get reference list
   */
   const getRefFeatures = async () => {
    const fields = ConfigService.getConfig().agol.operationalLayers.reportMain.fields;

    // Ref data    
    const countryFilter = "reporting_entity_type = '1' OR reporting_entity_type = '1,2'";
    //const initiativeFeature: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_RESTPLEDGE_INITIATIVE.index);
    const initiativeFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_INITIATIVE.index), countryFilter, false, '*','');

    //const ecosystemTypeFeature: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.index);
    const ecosystemTypeFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.index), countryFilter, false, '*','');

    //Anterior reports
    let where: string = `${fields.repYear} < ${props.state.report?.attributes[fields.repYear]} AND ${fields.gid0} = '${props.state.report?.attributes[fields.gid0]}'`;

    if(props.state.report?.attributes[fields.gid1]) {
      where = `${where} AND ${fields.gid1} = '${props.state.report?.attributes[fields.gid1]}'`;
    }
      
    const anteriorReportsFeatures = await QueryService.queryFeatures(Utils.getOpLayerQuery(ConfigService.getConfig().agol.operationalLayers.reportMain.index), where, false, '*', `${fields.repYear} DESC`);

    const obj: ILocalState = { ...localState };
    obj.refPledgeInitiativeFeature = initiativeFeature.map((feat: IFeature) => feat.attributes as IRefPledgeInitiativeFeature);
    obj.refPledgeEcosystemTypeFeature = ecosystemTypeFeature.map((feat: IFeature) => feat.attributes as IRefPledgeEcosystemTypeFeature);
    
    
    if(anteriorReportsFeatures && anteriorReportsFeatures.length > 0) {
      obj.importReportDisabled = false;
      obj.anteriorReport = anteriorReportsFeatures[0] as IReportMainFeature;
    } else {
      obj.importReportDisabled = true;
    }

    setTheLocalState(obj);
    
    // Validate data
    setValidState();
  };

  /**
  * Set valid state
  */
  const setValidState = () => {
    const obj2: IEditReportState = {...props.state};
    const subObj: IRestorationPledgeTab = { ...obj2.restorationPledgeTab } as IRestorationPledgeTab;
    
    if(subObj) {
      props.validateData(subObj);
    }

    obj2.restorationPledgeTab = subObj;
    props.setState(obj2);
  }

  /**
   * Handle import report
   */
  const importReport = () => {
    // toast('This feature is not yet available');

    if(localState && localState.anteriorReport && props.state) {
      const obj: IEditReportState = {...props.state};
      const subObj: IRestorationPledgeTab = { ...obj.restorationPledgeTab } as IRestorationPledgeTab;
      
      subObj.ha_pledged = localState.anteriorReport.attributes.ha_pledged;
      subObj.baseline_year = localState.anteriorReport.attributes.baseline_year;
      subObj.pledge_start = localState.anteriorReport.attributes.pledge_start;
      subObj.pledge_end = localState.anteriorReport.attributes.pledge_end;
      subObj.linked_init = localState.anteriorReport.attributes.linked_init || '';
      subObj.linked_init_other = localState.anteriorReport.attributes.linked_init_other || '';
      subObj.ecosystems = localState.anteriorReport.attributes.ecosystems || '';
      subObj.ecosystems_other = localState.anteriorReport.attributes.ecosystems_other || '';
      subObj.links = localState.anteriorReport.attributes.links || '';

      obj.restorationPledgeTab = subObj;

      props.setState(obj);
    }
  }

  /**
   * Check if a field is required
   * @param field
   */
   const isRequired = (field: string): boolean => {
    return Utils.isRequiredField(ConfigService.getConfig().agol.operationalLayers.reportMain.requiredFields.restorationPledge, field);
  }

  return(
    <div className="oneTabContent restorationPledgeTab">
      <span className="bigText">{t('newReport.restorationPledge.label')}</span>
      <button className="primary importBtn" disabled={localState.importReportDisabled} onClick={importReport}>{t('newReport.restorationPledge.importReport')}</button>

      <div className="separtorDiv"></div>

      <div className="row">
        <span className="titleSpan mediumText">{t('newReport.restorationPledge.hectaresPledged')}</span>                       
        <input className="mediumText small" type="number" required = {isRequired('ha_pledged')}
        maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'ha_pledged')?.length} min={0} onKeyUp={Utils.preventNegativeValue}
        placeholder={t('newReport.restorationPledge.hectaresPledgedPlaceholder')} value={props.state.restorationPledgeTab?.ha_pledged || ''} onChange={(e) => {setParentState('ha_pledged', e.target.value)}}/>  
      </div>

      <div className="row">
        <span className="titleSpan mediumText">
          {t('newReport.restorationPledge.baselineYear')}
          <OverlayTrigger trigger="click" placement="right" rootClose overlay={baselineYearPopover}>      
          <button className="questionIcon" ref={(btn: HTMLButtonElement) => baselineYearPopoverBtn = btn }><FontAwesomeIcon icon={faQuestion}/></button>
          </OverlayTrigger>
        </span>                     
        <input className="mediumText small" type="number" required = {isRequired('baseline_year')}
        maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'baseline_year')?.length} min={1900} max={2100} onKeyUp={Utils.validateYear}
        placeholder={t('newReport.restorationPledge.baselineYearPlaceholder')} value={props.state.restorationPledgeTab?.baseline_year || ''} onChange={(e) => {setParentState('baseline_year', e.target.value)}}/>  
      </div>

      <div className="row">
        <span className="titleSpan mediumText">{t('newReport.restorationPledge.pledgeStartYear')}</span>
        <input className="mediumText small" type="number" required = {isRequired('pledge_start')}
        maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'pledge_start')?.length} min={1900} max={2100} onKeyUp={Utils.validateYear}
        placeholder={t('newReport.restorationPledge.pledgeStartYearPlaceholder')} value={props.state.restorationPledgeTab?.pledge_start || ''} onChange={(e) => {setParentState('pledge_start', e.target.value)}}/>  
      </div>

      <div className="row">
      <span className="titleSpan mediumText">
          {t('newReport.restorationPledge.pledgeEndDate')}
          <OverlayTrigger trigger="click" placement="right" rootClose overlay={pledgeEndDatePopover}>      
          <button className="questionIcon" ref={(btn: HTMLButtonElement) => pledgeEndDatePopoverBtn = btn }><FontAwesomeIcon icon={faQuestion}/></button>
          </OverlayTrigger>
        </span>
        <ReactDatePicker className= {isRequired('pledge_start') ? "required" : ""} selected={getPledgeEndDate()} onChange={(date: Date) => handlePledgeEndDateChange(date)}/>
        {/*<input className="mediumText small" type="text" disabled value={props.state.restorationPledgeTab?.pledgeEndDate}/>*/}
      </div>
      
      {localState.refPledgeInitiativeFeature && localState.refPledgeInitiativeFeature.length > 0 &&
      <div className={`row multiselectRow ${isRequired('linked_init') ? "required" : ""}`}>
        <span className="titleSpan mediumText">{t('newReport.restorationPledge.pledgeInitiative')}</span>

        <div className="col-6">
          <Select classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeInitiativePlaceholder')}
          closeMenuOnSelect={true} isMulti
          options={localState.refPledgeInitiativeFeature.map((i: IRefPledgeInitiativeFeature) => {return {label: i.value, value: i.key_}})}
          onChange={handleInitiativeChange}
          value={
            localState.refPledgeInitiativeFeature.map((i: IRefPledgeInitiativeFeature) => {return {label: i.value, value: i.key_}})
            .filter(option => (props.state.restorationPledgeTab?.linked_init || '').split(',').indexOf(option.value || '---') !== -1)
          }/>
        </div>

        <div className="col-6">                
          <input className="mediumText big right" type="text" required = {isRequired('linked_init_other')}
          maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'linked_init_other')?.length} placeholder={t('newReport.ifOtherSelected')}
          disabled={!localState.otherInitiativeInputEnabled} value={props.state.restorationPledgeTab?.linked_init_other} onChange={(e) => {setParentState('linked_init_other', e.target.value)}}/>  
        </div>
      </div>
      }

      {localState.refPledgeEcosystemTypeFeature && localState.refPledgeEcosystemTypeFeature.length > 0 &&
      <div className={`row multiselectRow ${isRequired('ecosystems') ? "required" : ""}`}>
        <span className="titleSpan mediumText">{t('newReport.restorationPledge.pledgeEcosystem')}</span>

        <div className="col-6">
          <Select classNamePrefix="multiselect" placeholder={t('newReport.restorationPledge.pledgeEcosystemPlaceholder')}
          closeMenuOnSelect={true} isMulti
          options={localState.refPledgeEcosystemTypeFeature.map((i: IRefPledgeEcosystemTypeFeature) => {return {label: i.value, value: i.key_}})}
          onChange={handleEcosystemChange}
          value={
            localState.refPledgeEcosystemTypeFeature.map((i: IRefPledgeEcosystemTypeFeature) => {return {label: i.value, value: i.key_}})
            .filter(option => (props.state.restorationPledgeTab?.ecosystems || '').split(',').indexOf(option.value || '---') !== -1)
          }/>
        </div>

        <div className="col-6">                
          <input className="mediumText big right" type="text" required = {isRequired('ecosystems_other')}
          maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'ecosystems_other')?.length} placeholder={t('newReport.ifOtherSelected')}
          disabled={!localState.otherEcosystemInputEnabled} value={props.state.restorationPledgeTab?.ecosystems_other} onChange={(e) => {setParentState('ecosystems_other', e.target.value)}}/>  
        </div>
      </div>
      }

      <div className="row">
        <span className="titleSpan mediumText">{t('newReport.restorationPledge.pledgeAnnouncementLinks')}</span>                       
        <textarea className="commonText medium" required = {isRequired('links')}
        maxLength={Utils.getFieldInfos(localState.reportLayerIndex, 'links')?.length}
        rows={5} placeholder={t('newReport.restorationPledge.pledgeAnnouncementLinksPlaceholder')} value={props.state.restorationPledgeTab?.links}  onChange={(e) => {setParentState('links', e.target.value)}}/>
      </div>

      <ToastContainer 
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover/>

    </div>
  );
};

export default RestorationPledge;

